export default __webpack_public_path__ + "static/media/KSURF.2ab5d902.png";